import keysCollection from '../../utilities/keysCollection'

export const Keys = keysCollection('ROLES', {
    CATEGORY: 'CATEGORY',
    STATE: 'STATE',
    MODAL_ROL: 'MODAL_ROL',
    ROL: 'ROL',
    DEPARTMENT: 'DEPARTMENT'
})
